import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleRightSmallOutlined as C } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-right-small-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { theme } from "../../../foundations/theme.es.js";
import { Button } from "../../button/button.es.js";
const WorkingTurnAction = {
  cafOperator: /* @__PURE__ */ jsx(C, { customColor: theme.palette.action.active }),
  user: /* @__PURE__ */ jsx(Button, { color: "primary", size: "medium", variant: "contained", endIcon: /* @__PURE__ */ jsx(C, { color: "inherit" }), children: "Procedi" }),
  finalized: /* @__PURE__ */ jsx(C, { customColor: theme.palette.action.active })
};
export {
  WorkingTurnAction
};
//# sourceMappingURL=turn-action-component.es.js.map
